(function ($, Drupal) {
  Drupal.behaviors.nppeTttArticleFull = {
    attach: function (context) {
      // ---------
      const $window = $(window);
      const $ct = $(context).find('.node--type-nppe-article');
      const $layoutBuilderLinks = $ct.find('#pel-builder h2, #pel-builder h3');
      // Avoid problems with achors inside the layout builder before use these elements.
      $layoutBuilderLinks.prop('id', 'layoutBuilderId');
      const $progressBarWrapper = $ct.find('.article--progressbar');
      const $articleHero = $ct.find('.article--hero');
      const $progressBar = $ct.find('.progressbar-main-bar');
      const $progressBarAnchors = $ct.find('.article--anchors');
      const $pgDropDownButtonWrapper = $ct.find('.article--dropbtn-wrapper');
      const $pgDropDownButton = $ct.find('.article--dropbtn');
      const $pgDropDownContent = $ct.find('.article--dropdown-content');
      const $pgDropDownItems = $ct.find('.article--dropdown-content li');
      const $pgDropDownLinks = $pgDropDownItems.find('a');
      const $pgSuggestedProducts = $ct.find('.progressbar--suggested-products');
      const $suggestedProductsComponent = $ct.find('.component--products-list');
      const $articleAuthor = $ct.find('.hero--article-author-heading');
      const scrollItems = $pgDropDownLinks.map(function () {
        var item = $($(this).attr('href'));
        if (item.length) {
          return item;
        }
      });
      var mobile = true;
      var paddingOffset = 80;
      var extraOffset = 20;
      var lastId;

      $(once('alerts-wrapper', $ct, context)).each(function () {
        // @fixme we are forced to expose $() since DOMElementRelocation
        //    does not suport JQuery()
        window.$ = jQuery;

        new DOMElementRelocation({
          breakpoints: {
            desk: '(min-width: 1140px)',
            mob: '(min-width: 0px) and (max-width: 1139px)'
          },
          elements: [{
            element: '.field--name-field-article-sidebar-block',
            mob: '.mobile-placeholder--article-sidebar-block',
            desk: false
          }]
        });

        // Define the media query.
        $window.mediaQueryEvents({
          breakpoints: {
            'article_mobile': '(min-width: 0px) and (max-width: 1139px)',
            'article_desktop': '(min-width: 1140px)'
          }
        });

        // Listen mobile breakpoint.
        $window.on('mq.article_mobile', function () {
          mobile = true;
          extraOffset = 20;
          paddingOffset = 80;
        });

        // Listen desktop breakpoint.
        $window.on('mq.article_desktop', function () {
          mobile = false;
          extraOffset = 50;
          paddingOffset = 50;
        });

        // Make the progress bar sticky and increase/decrease when scroll.
        if ($progressBarWrapper && $progressBarWrapper.length) {
          var progressbarOffset = $progressBarWrapper.offset().top;
        }
        var progressbarHeight = $progressBarWrapper.height();

        $window.scroll(function () {
          // eslint-disable-next-line max-len
          var vHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
          var barWidth = (document.documentElement.scrollTop * 100 / vHeight);
          $progressBar.css('width', barWidth + '%');

          if (mobile) {
            if (($window.scrollTop()) > (progressbarOffset + progressbarHeight)) {
              $progressBarWrapper.addClass('sticky');
              $articleHero.css('paddingTop', progressbarHeight + 'px');
            }
            else {
              $progressBarWrapper.removeClass('sticky');
              $articleHero.css('paddingTop', 0);
            }
          }
        });

        // Set the dropdown text with the first element.
        $pgDropDownButton.text($pgDropDownItems.eq(0).text());
        $pgDropDownItems.eq(0).addClass('active');

        // Dropdown functionality.
        $pgDropDownButtonWrapper.on('click', function () {
          // eslint-disable-next-line max-len
          $pgDropDownContent.add($pgDropDownButtonWrapper).add($pgSuggestedProducts).add($progressBarWrapper).toggleClass('open');
        });

        // Close dropdown when the user clicks outside.
        $(document).mouseup(function (e) {
          // If the target of the click isn't the container nor a descendant of the container.
          if ($pgDropDownButtonWrapper.hasClass('open') &&
						!$progressBarAnchors.is(e.target) &&
						$progressBarAnchors.has(e.target).length === 0
          ) {
            // eslint-disable-next-line max-len
            $pgDropDownContent.add($pgDropDownButtonWrapper).add($pgSuggestedProducts).add($progressBarWrapper).removeClass('open');
          }
        });

        $pgDropDownItems.on('click', function (e) {
          e.preventDefault();

          // Store hash.
          var hash = $(this).find('a')[0].hash;

          $('html, body').animate({
            scrollTop: $(hash).offset().top + getOffset()
          }, 100);

          $pgDropDownButton.text($(this).text());
          $pgDropDownItems.add($pgDropDownContent.find('li .active')).removeClass('active');
          $(this).addClass('active');
          // eslint-disable-next-line max-len
          $pgDropDownContent.add($pgDropDownButtonWrapper).add($pgSuggestedProducts).add($progressBarWrapper).removeClass('open');
        });

        $pgSuggestedProducts.on('click', function () {
          $pgDropDownItems.removeClass('active');
          // eslint-disable-next-line max-len
          $pgDropDownContent.add($pgDropDownButtonWrapper).add($pgSuggestedProducts).add($progressBarWrapper).removeClass('open');
          $pgDropDownButton.text($(this).text());

          $('html, body').animate({
            scrollTop: $suggestedProductsComponent.offset().top + getOffset()
          }, 800);
        });

        $articleAuthor.on('click', function () {
          $('html, body').animate({
            scrollTop: $('.article-author-bottom').offset().top - ($(window).height() / 2) + ($('.article-author-bottom').outerHeight() / 2)
          }, 500);
        });
      });

      // Change dropdown label while scrolling.
      $(window).scroll(function () {
        // Get container scroll position.
        var fromTop = $(this).scrollTop();
        // console.log(fromTop)

        // Get id of current scroll item.
        var cur = scrollItems.map(function () {
          if ($(this).offset().top < fromTop - getOffset() + extraOffset) {
            return this;
          }
        });

        // console.log(cur)

        // Get the id of the current element.
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : '';

        if (id === '') {
          id = lastId;
        }

        if (lastId !== id) {
          lastId = id;

          // Set/remove letter-active class
          $pgDropDownLinks
            .parent().removeClass('active')
            .end().filter('[href=\'#' + id + '\']').parent().addClass('active');
          // Change the dropdown label with the active text.
          $pgDropDownButton.text($pgDropDownLinks.filter('[href=\'#' + id + '\']').text());
        }
      });

      function getOffset () {
        var offsetValue = 0;
        if (mobile) {
          // Offset of the sticky menu with 45px or 10px of paddings.
          offsetValue = offsetValue - $pgDropDownButtonWrapper.height() - paddingOffset;
        }
        else {
          offsetValue = offsetValue - paddingOffset;
        }
        return offsetValue;
      }
      // ---------
    }
  };
})(jQuery, Drupal);
